import dybContent from './settings/DYB/static/content';
import cbContent from './settings/CB/static/content';
import ybContent from './settings/YB/static/content';
import vmContent from './settings/VM/static/content';

export default brand => {
  switch (brand) {
    case 'CB':
      return cbContent();
    case 'YB':
      return ybContent();
    case 'VM':
      return vmContent();
    default:
      return dybContent();
  }
};
